import * as t from "io-ts";
import { CallResponseSchemaNoData } from "../common/callResponseSchema";

export const challengeTextFields = ["title", "subtitle", "description", "goal"] as const;
export type ChallengeTextField = (typeof challengeTextFields)[number];
export const ChallengeTextSchema = t.type({ title: t.string, subtitle: t.string, description: t.string, goal: t.string });
export type ChallengeText = t.TypeOf<typeof ChallengeTextSchema>;
export const ChallengeTranslationsSchema = t.partial(ChallengeTextSchema.props);

// Keep the existing keys so all VR/mobile consumers and existing translations continue to work.
export const getChallengeLocizeKeyPrefix = (challenge: { title?: string } | null) =>
  `challenges.challenge.${challenge?.title?.toLowerCase().replace(/ /g, "-")}`;
export const challengeLocizeSuffixes: Record<ChallengeTextField, string> = {
  title: "name",
  subtitle: "caption",
  description: "description",
  goal: "goal",
};

export const ChallengeLocalizationRequestSchema = t.intersection([
  t.type({ challenge_id: t.number, version: t.keyof({ latest: null, production: null }) }),
  t.union([
    t.type({ action: t.literal("read"), language: t.string }),
    t.type({ action: t.literal("sync") }),
    t.type({ action: t.literal("save"), language: t.string, key_prefix: t.string, translations: ChallengeTranslationsSchema }),
  ]),
]);
export const ChallengeLocalizationDataSchema = t.type({
  key_prefix: t.string,
  version: t.string,
  source: ChallengeTextSchema,
  source_translations: ChallengeTranslationsSchema,
  language: t.string,
  translations: ChallengeTranslationsSchema,
  languages: t.array(t.type({ code: t.string, name: t.string })),
});
export type ChallengeLocalizationData = t.TypeOf<typeof ChallengeLocalizationDataSchema>;
export const ChallengeLocalizationResponseSchema = t.intersection([CallResponseSchemaNoData, t.type({ data: ChallengeLocalizationDataSchema })]);
